import React from 'react';

export const ServiceFee = ({ serviceFees, amount }) => {
  // Find the appropriate service fee range for the given amount
  const fee = serviceFees.find(({ range }) => amount >= range.min && amount <= range.max);

  // Display the result
  return <div>{fee ? <p>{fee.percentage}%</p> : <p></p>}</div>;
};
